import { render } from "./QEnvironmentalFactors.vue?vue&type=template&id=641f56d4&ts=true"
import script from "./QEnvironmentalFactors.vue?vue&type=script&lang=ts"
export * from "./QEnvironmentalFactors.vue?vue&type=script&lang=ts"

import "./QEnvironmentalFactors.vue?vue&type=style&index=0&id=641f56d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__